import InvestmentAmountInput from "./InvestmentAmountInput";

export default InvestmentAmountInput;